import { get, normalizeUri, splitTags, parseSiteMediaToken } from '../../../utils/utils';
import { mmgrVersions } from '../../../constants/mmgr-version';
import { getWixThumbnailsUrls, getWixVideoPreviewUrls } from '@wix/thumbnail-generator';
import { ItemKind } from '../../../constants/ItemKind';
import { systemFolderId } from '../../../constants/system-folder-id';
import { toObject } from '../../../utils/mappers';
import { MediaType } from '../../../constants/MediaType';
export function toItem(itemData, settings, thumbnailSizes) {
  const source = itemData.root_id === systemFolderId.VisitorUploads ? 'visitorsUploads' : 'private';
  let item = {
    id: itemData.file_name,
    kind: ItemKind.File,
    source: settings.sourceName || source,
    folderId: itemData.parent_folder_id || null,
    fileSize: itemData.file_size,
    name: itemData.original_file_name,
    mediaType: itemData.media_type,
    fileUrl: itemData.file_url ? normalizeUri(itemData.file_url) : null,
    sourceUrl: itemData.source_url || null,
    createdAt: itemData.created_ts,
    updatedAt: itemData.modified_ts,
    readOnly: itemData.read_only || null,
    labels: itemData.labels || [],
    tags: splitTags(itemData.tags),
    width: itemData.width || null,
    height: itemData.height || null,
    fileInfo: itemData.file_info ? toObject(itemData.file_info) : null,
    fileInput: itemData.file_input ? toObject(itemData.file_input) : null,
    fileOutput: itemData.file_output ? toObject(itemData.file_output) : null,
    transcodingStatus: itemData.op_status,
    siteId: itemData.site_id,
    userId: itemData.user_id,
    boardId: itemData.board_id,
    siteMediaToken: itemData.token || settings.siteMediaToken
  };
  if (item.mediaType === MediaType.Video) {
    item.width = get(item, 'fileOutput.image[0].width', itemData.width);
    item.height = get(item, 'fileOutput.image[0].height', itemData.height);
  }
  const sizes = {
    ...settings.thumbnailSizes,
    ...thumbnailSizes
  };
  item = {
    ...item,
    ...getWixThumbnailsUrls(item, sizes, settings, mmgrVersions.G6)
  };
  if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
    item.thumbnailUrl = normalizeUri(settings.filesUrl + "/" + itemData.icon_url);
  }
  Object.keys(sizes).forEach(function (thumbType) {
    const thumbnailPropertyName = thumbType + "Url";
    if (!item[thumbnailPropertyName]) {
      item[thumbnailPropertyName] = item.thumbnailUrl;
    }
    if ([MediaType.Document, MediaType.SecureDocument, MediaType.Archive, MediaType.SecureArchive].indexOf(item.mediaType) !== -1) {
      const {
        siteMediaToken
      } = settings;
      const userId = parseSiteMediaToken(siteMediaToken).userId;
      const userFilesRestUrl = settings.privateFilesUrl.replace('<msid>', userId);
      item[thumbnailPropertyName] = userFilesRestUrl + "/" + item.fileUrl;
    }
  });
  Object.keys(item).forEach(function (prop) {
    if (item[prop] === undefined) {
      delete item[prop];
    }
  });
  item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings) || null;
  return item;
}